module.exports = __webpack_public_path__ + "img/claim-reward.47788043.png";